import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
let HospInfo = class HospInfo extends Vue {
    mounted() {
        // const that: any = this;
    }
};
__decorate([
    Getter
], HospInfo.prototype, "userInfo", void 0);
HospInfo = __decorate([
    Component({
        name: 'HospitalInfoDetail',
    })
], HospInfo);
export default HospInfo;
;
